<template>
	<!-- 쿠팡 센터별 입고 진행(#50) — 수집된 입고 진행 스냅샷 기준. 소요일이 아니라 «예정일 지난 건수·지난 일수» 다 -->
	<div class="card mb-2 scm-inbound">
		<div class="card-body py-2 px-3">
			<div class="d-flex align-items-center justify-content-between scm-inbound__head" role="button" @click="open = !open">
				<div>
					<strong>센터별 입고 진행</strong>
					<small class="text-muted ml-2" v-if="loaded">진행 {{ total.toLocaleString() }}건 · 센터 {{ centers.length }}곳 · 예정일 지남 {{ overdueTotal.toLocaleString() }}건</small>
				</div>
				<small class="text-primary">{{ open ? '접기' : '펼치기' }}</small>
			</div>
			<b-collapse v-model="open">
				<div class="mt-2">
					<p v-if="error" class="text-danger mb-0">{{ error }}</p>
					<p v-else-if="loaded && !centers.length" class="text-muted mb-0">진행 중인 입고가 없어요. 상품 정보를 수집하면 여기에 센터별로 보여요.</p>
					<div v-else-if="loaded" class="table-responsive">
						<table class="table table-sm table-bordered mb-1 scm-inbound__table">
							<thead class="thead-light">
								<tr>
									<th>센터</th>
									<th class="text-right">진행 중</th>
									<th class="text-right" v-for="s in statuses" :key="s">{{ statusLabel[s] || s }}</th>
									<th class="text-right">예정일 지남</th>
									<th class="text-right">지난 일수(중앙값)</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="c in centers" :key="c.fcCode || c.fcName">
									<td>{{ c.fcName }}</td>
									<td class="text-right">{{ c.inProgress }}</td>
									<td class="text-right" v-for="s in statuses" :key="s">{{ c.byStatus[s] || 0 }}</td>
									<td class="text-right" :class="{ 'text-danger font-weight-bold': c.overdue > 0 }">{{ c.overdue }}</td>
									<td class="text-right">{{ c.overdueDaysMedian == null ? '-' : c.overdueDaysMedian + '일' }}</td>
								</tr>
							</tbody>
						</table>
						<small class="text-muted">{{ today }} 기준 · 쿠팡이 알려 준 입고 예정일보다 늦어지고 있는 건을 셉니다(마지막 수집 시점 상태).</small>
					</div>
					<!-- 센터별 소요일(#214) — 최근 N일 진열 시작한 입고 · 요청→진열 시작 · 빠른 순 -->
					<div v-if="loaded && !error" class="table-responsive mt-3">
						<strong class="d-block mb-1">센터별 입고 소요일 <small class="text-muted">최근 {{ leadtime.days }}일 진열 시작 {{ leadtime.total.toLocaleString() }}건 · 빠른 순</small></strong>
						<p v-if="!leadtime.centers.length" class="text-muted mb-0">아직 센터별 기록이 없어요. 확장 프로그램이 새 버전으로 입고 내역을 다시 수집하면 쌓여요.</p>
						<table v-else class="table table-sm table-bordered mb-1 scm-inbound__table">
							<thead class="thead-light">
								<tr>
									<th>센터</th>
									<th class="text-right">입고 건수</th>
									<th class="text-right">요청→진열(중앙값)</th>
									<th class="text-right">예정일보다 늦음</th>
									<th class="text-right">늦은 일수(중앙값)</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="c in leadtime.centers" :key="c.fcCode">
									<td>{{ c.fcName }}</td>
									<td class="text-right">{{ c.count }}</td>
									<td class="text-right">{{ c.leadDaysMedian }}일</td>
									<td class="text-right" :class="{ 'text-danger font-weight-bold': c.late > 0 }">{{ c.late }}</td>
									<td class="text-right">{{ c.lateDaysMedian == null ? '-' : c.lateDaysMedian + '일' }}</td>
								</tr>
							</tbody>
						</table>
						<small v-if="leadtime.centers.length" class="text-muted">입고 요청한 때부터 쿠팡이 진열을 시작한 때까지 걸린 날입니다.</small>
					</div>
					<p v-else class="text-muted mb-0">불러오는 중…</p>
				</div>
			</b-collapse>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'ScmInboundByCenter',
	data() {
		return {
			open: false,
			loaded: false,
			error: '',
			today: '',
			total: 0,
			statuses: [],
			centers: [],
			leadtime: { days: 30, total: 0, centers: [] },
			statusLabel: { INIT_COMPLETED: '입고 대기', UNLOADING: '하차', RECEIVING: '입고 중', STOWING: '진열 중' },
		};
	},
	computed: {
		overdueTotal() {
			return this.centers.reduce((n, c) => n + (c.overdue || 0), 0);
		},
	},
	mounted() {
		this.load();
	},
	methods: {
		async load() {
			try {
				const { data } = await axios.post('/api/getScmInboundByCenter', {});
				if (!data || !data.ok) { this.error = '센터별 입고 진행을 불러오지 못했어요.'; return; }
				this.today = data.today;
				this.total = data.total;
				this.statuses = data.statuses || [];
				this.centers = data.centers || [];
				if (data.leadtime) this.leadtime = data.leadtime;
			} catch (e) {
				console.error('[ScmInboundByCenter] load', e);
				this.error = '센터별 입고 진행을 불러오지 못했어요.';
			} finally {
				this.loaded = true;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.scm-inbound {
	&__head { cursor: pointer; flex-wrap: wrap; gap: 4px; }
	&__table { font-size: 12px; white-space: nowrap; }
}
</style>
